import React from 'react';
import { useTranslation } from 'react-i18next';

const TranscendTheOrdinary = () => {
  const { t } = useTranslation();
  return (
    <div className="bg-white">
      <div className="bg-[#0A0A0A] w-full pt-20 md:pt-[172px] pb-[385px] px-5 sm:px-10">
        <h3 className="text-[17px] sm:text-[22px] leading-[28px] libre-baskerville font-normal text-white text-center mb-5">
          {t('about.transcend.title')}
        </h3>
        <h1 className="text-white text-[40px] leading-[50px] md:text-[60px] lg:text-[76.5px] md:leading-[70px] lg:leading-[100px] libre-baskerville max-w-[804px] mx-auto text-center">
          {t('about.transcend.heading')}
        </h1>
      </div>
      <div className="px-5">
        <div
          className="max-w-[1196px] flex items-center pt-20 md:pt-0 justify-center -mt-[300px] flex-col gap-[23.19px] mx-auto relative min-h-[598px] bg-cover bg-center bg-no-repeat rounded-[16px]"
          style={{ backgroundImage: "url('/assets/about-banner.webp')" }}
        >
          <h4 className=" px-[15px] md:pl-10 lg:pl-[90px] text-white text-[14px] leading-[24px] font-medium underline underline-offset-8">
            {t('about.transcend.cta')}
          </h4>
          <p className="text-[22px] md:text-[31.7px] text-center leading-[30px] md:leading-[50.69px] font-normal libre-baskerville text-white relative z-10 max-w-[400px] md:text-left px-[15px] md:pl-10 lg:pl-[90px] md:pr-6">
            {t('about.transcend.subheading')}
          </p>
        </div>
        <div className="max-w-[600px] mx-auto w-full text-center mt-[57px] md:mt-[135px] mb-[115px] md:mb-[214px]">
          <h2 className="text-[#1D1D1F] text-[24px] sm:text-[31.7px] leading-[38px] sm:leading-[50.69px] font-normal libre-baskerville">
            {t('about.transcend.description')}
          </h2>
          <h4 className="mt-[18px] sm:mt-8 text-[#1D1D1F] text-[17px] leading-[30px] font-medium underline underline-offset-8">
            {t('about.transcend.linkLabel')}
          </h4>
        </div>
      </div>
    </div>
  );
};

export default TranscendTheOrdinary;
